import React from "react"
import BikesCollectionItem from "./BikesCollectionItem/BikesCollectionItem"
import StaticTile from "./StaticTile"

type PLPBikesListProps = {
  filteredBikes: any[];
  isListView: boolean;
  isMobile: boolean;
  isOccasionContent?: boolean;
  jumpsNumber: number;
  tileArrayLength: number;
};

const PLPBikesList: React.FC<PLPBikesListProps> = ({
	filteredBikes,
	isListView,
	isMobile,
	isOccasionContent,
	jumpsNumber,
	tileArrayLength
}) => {
	let count = 0
	const cardWidthOnDesktop = filteredBikes.length < 3 ? "278px" : "100%"

	return (
		<>
			{filteredBikes.map((bike, index) => {
				if ((index + 1) % jumpsNumber === 0 && count < tileArrayLength + 1) {
					count++
				}

				const isAccessory = bike?.categories?.find(cat => ["accessoires", "zubehoer"].includes(cat.slug))
				const isLast = index === filteredBikes.length - 1
				const isMobileView = isMobile && !isListView
				const cardWidth = isMobileView ?
					"163px" :
					isMobile && !isListView ?
						"188px" :
						isOccasionContent ?
							"306px" : isListView ? "343px" :
								cardWidthOnDesktop

				return (
					<React.Fragment key={index}>
						<BikesCollectionItem
							listView={isListView}
							cardWidth={cardWidth}
							isIkeaDesign={true}
							isAccessory={isAccessory}
							isLast={isLast}
							isRowForMobile={isMobile}
							isTwoCardsView={isMobile}
							bike={bike}
							withArrows={!isMobile}
							withDots
						/>

						{/* StaticTile rendering logic */}
						{(index + 1) % jumpsNumber === 0 ?
							count < tileArrayLength + 1 ? <>
								{isListView ? <div className={`${isListView ? "col-12 my-3" : "col-md-6 col-lg-4 col-xxl-3"}`}
									style={{maxHeight: 440}}>
									<StaticTile isIkeaDesign
										key={`static-tile-${index}`}
										index={count}/>
								</div> : <StaticTile isIkeaDesign
									key={`static-tile-${index}`}
									index={count}/>}</> :
								null : null}
					</React.Fragment>
				)
			})}
		</>
	)
}

export default PLPBikesList
